// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lu-0";
export var assigneeDetails = "_lu-1";
export var assigneeInfo = "_lu-2";
export var dropdownContainer = "_lu-4";
export var dropdownImage = "_lu-5";
export var editAssigneeInfo = "_lu-3";
export var editAssigneeModalContainer = "_lu-6";
export var hidden = "_lu-8";
export var input = "_lu-7";